module.exports = __webpack_public_path__ + "media/images/lp_seiho/sec02_img_02-b4cd6fbe48a8e4714f2c060d9ef8396a.png";